var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.5,
    width: 42,
    height: 42,
    rx: 21,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.5,
    width: 42,
    height: 42,
    rx: 21,
    stroke: "#40C5E8",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7046 30.7785L26.3251 25.3989C27.375 24.0453 28 22.3457 28 20.5C28 16.0817 24.4183 12.5 20 12.5C15.5817 12.5 12 16.0817 12 20.5C12 24.9183 15.5817 28.5 20 28.5C21.8457 28.5 23.5453 27.875 24.8989 26.8251L30.2785 32.2046C30.6723 32.5985 31.3108 32.5985 31.7046 32.2046C32.0985 31.8108 32.0985 31.1723 31.7046 30.7785ZM26 20.5C26 23.8137 23.3137 26.5 20 26.5C16.6863 26.5 14 23.8137 14 20.5C14 17.1863 16.6863 14.5 20 14.5C23.3137 14.5 26 17.1863 26 20.5Z",
    fill: "#40C5E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchOpen);
export default __webpack_public_path__ + "static/media/search-open.d1909d81bce2414458bbebb66f107984.svg";
export { ForwardRef as ReactComponent };